export default "__VITE_ASSET__BupsAJzO__"